// extracted by mini-css-extract-plugin
export default {"articleTitle":"certificateCharge_articleTitle__WYQx+","row":"certificateCharge_row__hYHm+"};